export enum ProductsLayoutTypes {
    page = 'page',
    section = 'section'
}